import { InputField } from "../../common/ui/inputField";
import { Button } from "../../common/ui/button/button";
import { DeleteButton } from "../../common/ui/button/icon/deleteButton";

interface SectionRecipientsListProps {
  recipients: string[];
  newRecipient: string;
  onNewRecipientChange: (value: string) => void;
  onAdd: () => void;
  onRemove: (email: string) => void;
}

export const SectionRecipientsList = ({
  recipients,
  newRecipient,
  onNewRecipientChange,
  onAdd,
  onRemove,
}: SectionRecipientsListProps) => {
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <InputField
          type="email"
          value={newRecipient}
          onChange={(e) => onNewRecipientChange(e.target.value)}
          placeholder="Agregar destinatario"
          className="flex-1 mb-0"
          inputClassName="flex-1"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onAdd();
            }
          }}
        />
        <Button
          type="button"
          onClick={onAdd}
          disabled={!newRecipient.trim()}
          text="Agregar destinatario"
        />
      </div>

      {recipients.length > 0 && (
        <ul className="space-y-1">
          {recipients.map((email) => (
            <li
              key={email}
              className="flex items-center justify-between px-3 py-1.5 rounded-md bg-global-primary border border-global-secondary"
            >
              <span className="text-size-xs text-global-primary font-medium truncate">
                {email}
              </span>
              <DeleteButton onClick={() => onRemove(email)} title="Eliminar" />
            </li>
          ))}
        </ul>
      )}

      {recipients.length === 0 && (
        <p className="text-size-2xs text-global-muted px-1">
          No hay destinatarios configurados
        </p>
      )}
    </div>
  );
};
